module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0151.jpg?v=62890295";